module.exports = __webpack_public_path__ + "static/media/background-triangles.9e3fe755.svg";